import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, App } from "antd";
import { MessageOutlined, HistoryOutlined } from "@ant-design/icons";
import { useCreateConversation } from "../../api/queries";

/**
 * Quick entry buttons for the top bar: create a new conversation and open
 * the conversation history list. Self-contained — no props.
 */
export default function ConversationQuickActions() {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const createConversation = useCreateConversation();

  const handleNew = useCallback(async () => {
    if (createConversation.isPending) return;
    try {
      const result = await createConversation.mutateAsync({ mode: "explore" });
      if (result?.data?.id) {
        navigate(`/history/${result.data.id}`);
      }
    } catch {
      message.error("创建对话失败，请稍后重试");
    }
  }, [createConversation, navigate]);

  const handleHistory = useCallback(() => {
    navigate("/history");
  }, [navigate]);

  return (
    <div
      style={{
        display: "inline-flex",
        gap: "var(--jerry-sp-1)",
      }}
    >
      <Button
        type="default"
        size="middle"
        icon={<MessageOutlined />}
        loading={createConversation.isPending}
        onClick={handleNew}
        data-testid="new-conversation-button"
      >
        新会话
      </Button>
      <Button
        type="default"
        size="middle"
        icon={<HistoryOutlined />}
        onClick={handleHistory}
        data-testid="history-conversation-button"
      >
        历史会话
      </Button>
    </div>
  );
}
